import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
// todo: add back once the expose proper export
// import type { LeafContentCard } from '@cigna/leaf-web/lib/wc';
// https://github.com/cigna-group/leaf-web/issues/430
import '@cigna/leaf-web/lib/wc/components/content-card/content-card';

@Component({
  selector: 'cigna-leaf-content-card',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-content-card
      [bodyFlexDirection]="bodyFlexDirection"
      [hideDividers]="hideDividers"
    >
      <ng-content></ng-content>
    </leaf-content-card>
  `,
})
export class CignaLeafContentCardComponent {
  @Input() bodyFlexDirection: 'column' | 'row' = 'row';
  @Input() hideDividers?: boolean;
}
